import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { SessionData } from './types';

export function useSession() {
  return useQuery({
    queryKey: ['me'],
    queryFn: ({ signal }) => api.get<SessionData>('/api/me', signal),
    retry: false,
    staleTime: 30_000,
  });
}
